module.exports = __webpack_public_path__ + "202408221624/img/wunai.85906895.png";